import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export type CommonFAQSchema = {
  faqId: number | string
  active: boolean
  faqSection: string
  faqText: string
  faqHtmlText: string | null
  faqLanguage: string
  faqCategory: "COMMON"
  faqType: number
}
export interface GetDeviceIdResponseData extends ResponseData {
  data: CommonFAQSchema[]
}
export interface GetDeviceIdResponse extends AxiosResponse {
  data: GetDeviceIdResponseData
}

export function getCommonFAQAPI(
  axiosInstance: AxiosInstance,
): Promise<GetDeviceIdResponse> {
  return axiosInstance({
    data: { avoidClientSideAuth: true },
    method: "get",
    url: "/home/common-faqs",
  }) as Promise<GetDeviceIdResponse>
}
